export enum CarouselDataSource {
	personalisedSpecials = 'PersonalisedSpecials',
	productGroup = 'ProductGroup',
	specials = 'specials',
	myFavourites = 'myfavourites',
}

export enum SelectedDataSource {
	SpecialsSortedFavourites = 'specials_sorted_favourites',
}
